"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../UserRegistrationScene/index.scss");
const react_router_dom_1 = require("react-router-dom");
const react_helmet_1 = __importDefault(require("react-helmet"));
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const UserRegistrationCompleteScene = () => {
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('user_registration_complete');
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: "User registration" }),
        react_1.default.createElement("main", { className: "user-registration-scene" },
            react_1.default.createElement("div", { className: "global-container after-reg" },
                react_1.default.createElement("h2", null, "Your account verification is in progress!"),
                react_1.default.createElement("p", null, "The MLC uses identity verification before a user is registered to comply with Know Your Customer (KYC) regulations. KYC is required to establish the legitimacy of a user's identity and helps to prevent the creation and use of fraudulent accounts."),
                react_1.default.createElement(react_router_dom_1.NavLink, { to: '/' }, "Go to Portal")))));
};
exports.default = UserRegistrationCompleteScene;
